import React, { useState } from 'react';
import './landingPageStyle.scss';
import { useNavigate } from 'react-router-dom';
import TextInput from '../components/ui/input/TextInput.js';
import GroupCommonButton from '../components/ui/button/GroupButton.js';
import RoundButton from '../components/ui/button/RoundButton.js';

import DocumentImage from '../assets/images/document.png';
import HandBoxImage from '../assets/images/handbox.png';
import PreviewDocumentImage from '../assets/images/preview-document.png';
import MotorInsurImage from '../assets/images/motor-insure.png';
import PolicyImage from '../assets/images/policy.png';
import PrimaryRoundButton from '../components/ui/button/PrimaryRoundButton.js';
import TopLandingNav from './TopLandingNav.js';
import Footer from './Footer.js';
import ConfirmBox from '../components/modal/ConfirmBox.js';
import { isValidOmanMobile } from '../helpers/validation.js';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { getValidAccessToken } from '../services/oauthservice.js';
import { createApiLog } from '../helpers/apiLogger.js';
import { createJourneyLog } from '../helpers/journeyLogger.js';
import { encryptRSA } from '../services/encrypt.js';

export default function LandingPage() {
  const [formData, setFormData] = useState({
    name: '',
    mobileNumber: '',
    termsCondition: false,
  });
  const [showModal, setShowModal] = useState(false);
  const [errMessage, setErrMessage] = useState('')
  const { partnerDetail } = useSelector((state) => state.domainReducer);
  const navigate = useNavigate();
  const { partnerConfig } = useSelector((state) => state.partnerConfig || {});
  const { JOURNEY_CODE, JOURNEY_ID } = partnerConfig || {};
  const handleLogin = (e) => {
    e.preventDefault();
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleOncheckbox = (e) => {
    setFormData({ ...formData, termsCondition: e.target.checked });
  };

  const validateForm = () => {
    const { name, mobileNumber, termsCondition } = formData;
    const { isValid = false, errMsg = '' } = isValidOmanMobile(mobileNumber)

    if (!name.trim()) {
      setErrMessage('Name is required')
      setShowModal(true)
      return false;
    }

    if (!isValid && errMsg !== '') {
      setErrMessage(errMsg)
      setShowModal(true)
      return isValid
    }

    if (!termsCondition) {
      setErrMessage('Please accept the privacy policy')
      setShowModal(true)
      return false;
    }

    return true;
  };

  const createMotorTrans = async (selectedOption) => {
    const data = {
      selectedOption: selectedOption,
      acceptPrivacyPolicy: formData.termsCondition,
      name: formData.name,
      mobileNo: formData.mobileNumber,
      partnerId: partnerDetail?.PARTNER_ID,
      journeyId: JOURNEY_ID,
      leadStatus: 'IN_PROGRESS',
      journeyStatus: 'LEAD_CAPTURED',
      journeyCode: JOURNEY_CODE
    }

    try {
      const encrypted = await encryptRSA({ ...data });
      const token = await getValidAccessToken();

      const response = await axios.post(
        `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        { encrypted },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      debugger
      await createApiLog({
        PARTNER_ID: partnerDetail?.PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: response.data.data,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: data,
        REQUEST_STATUS: "SUCCESS",
        RESPONSE: response,
      })

      return response.data
    } catch (error) {
      console.error('Error posting data:', error);

      await createApiLog({
        PARTNER_ID: partnerDetail?.PARTNER_ID,
        APP_ID: 1,
        COB: "MOTOR",
        TRANS_ID: formData?.transId,
        API: `${process.env.REACT_APP_DIC_ADMIN_API}/v1/motor/leads`,
        REQUEST: data,
        REQUEST_STATUS: "Failed",
        RESPONSE: error,
      })
    }
  }

  const createJourney = async (obj) => {
    const { transId, journeyStatus, remarks } = obj

    await createJourneyLog({
      PARTNER_ID: partnerDetail?.PARTNER_ID,
      APP_ID: 1,
      TRANS_ID: transId,
      JOURNEY_STATUS: journeyStatus,
      JOURNEY_ID: JOURNEY_ID,
      REMARKS: remarks
    })
  }

  const handleBuyPolicyClick = async () => {
    if (validateForm()) {
      try {
        const result = await createMotorTrans('Buy Policy')
        await createJourney({ transId: result.data, journeyStatus: "LEAD_CAPTURED", remarks: 'Journey started through buy policy' })
        navigate('/buy-policy', { state: { ...formData, transId: result.data } });
      } catch (error) {
        console.error('Error posting data:', error);
      }
    }
  };

  const handleRenewPolicyClick = async () => {
    if (validateForm()) {
     try {
       const result = await createMotorTrans('Renew Policy')
       await createJourney({ transId: result.data, journeyStatus: "LEAD_CAPTURED", remarks: 'Journey started through renew policy' })
       navigate('/renew-policy', { state: { ...formData, transId: result.data } });
    } catch (error) {
      console.error('Error posting data:', error);
    } 
    }
  };

  const handleRopClick = async () => {
    if (validateForm()) {
      try {
        const result = await createMotorTrans('ROP Resubmission')
        await createJourney({ transId: result.data, journeyStatus: "LEAD_CAPTURED", remarks: 'Journey started through rop resubmission' })
        const updatedData = { ...formData, transId: result.data }
        navigate('/rop-resubmission', { state: updatedData });
    } catch (error) {
      console.error('Error posting data:', error);
    }  
    }
  };

  const handlePayPremiumClick = async () => {
    if (validateForm()) {
      try {
        const result = await createMotorTrans('Pay Premium')
        await createJourney({ transId: result.data, journeyStatus: "LEAD_CAPTURED", remarks: 'Journey started through pay premium' })
        const updatedData = { ...formData, transId: result.data }
        navigate('/pay-premium', { state: updatedData });
      } catch (error) {
        console.error('Error posting data:', error);
      }  
    }
  };

  const handleReqPolDocClick = async () => {
    if (validateForm()) {
      try {
        const result = await createMotorTrans('Request Policy Document')
        await createJourney({ transId: result.data, journeyStatus: "LEAD_CAPTURED", remarks: 'Request Policy Document' })
        const updatedData = { ...formData, transId: result.data }
        navigate('/request-policy-document', { state: updatedData });
      } catch (error) {
        console.error('Error posting data:', error);
      }  
    }
  };

  const handleCloseConfirm = () => {
    setErrMessage('')
    setShowModal(false)
  }

  return (
    <>
      <ConfirmBox
        show={showModal}
        message={errMessage}
        onCancel={handleCloseConfirm}
      />
      <TopLandingNav />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#fff',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className='container-fluid  p-4 rounded'>
          <div className='container section-header'>
            <div className='row align-items-start'>
              <div className='col-md-7 mt-4'>
                <h2 className='section-text'>MOTOR INSURANCE</h2>
                <div className='row bg-image'>
                  <p className='bg-text'>
                    GET YOUR MOTOR INSURANCE POLICY
                    <p className='bg-text2'>
                      Protect your vehicle and your peace of mind
                    </p>
                  </p>
                </div>
              </div>

              <div className='col-md-5 mt-4'>
                <form onSubmit={handleLogin}>
                  <div className='row shadow p-3 mb-1 rounded'>
                    <div className='col-md-12 mt-4'>
                      <TextInput
                        label='Name'
                        type='text'
                        name='name'
                        value={formData.name}
                        onChange={handleChange}
                        placeholder='Name'
                        required={true}
                        requiredMsg='Please enter your Name'
                      />
                    </div>
                    <div className='col-md-12 mt-1'>
                      <TextInput
                        label='Mobile Number'
                        type='tel'
                        name='mobileNumber'
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        placeholder='Mobile Number'
                        required={true}
                        requiredMsg='Please enter your Mobile Number'
                      />
                      <div className='row mt-3'>
                        <div className='col-md-12'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            id='customCheck'
                            checked={formData.termsCondition}
                            onChange={handleOncheckbox}
                          />
                          <label
                            className='form-check-label ms-2'
                            htmlFor='customCheck'
                          >
                            I accept the &nbsp;
                            {/* <span class='text-decoration-underline'>
                              Terms & Conditions
                            </span>
                            &nbsp; and &nbsp; */}
                            <a href='https://dhofarinsurance.com/privacy-policy/'>
                              <span class='text-decoration-underline'>
                                Privacy Policy
                              </span>
                            </a>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12 mt-3'>
                      <GroupCommonButton
                        buttons={[
                          {
                            label: 'Buy Policy',
                            onClick: () => handleBuyPolicyClick(),
                            disabled: !formData.termsCondition,
                          },
                          {
                            label: 'Renew Policy',
                            onClick: () => handleRenewPolicyClick(),
                            disabled: !formData.termsCondition,
                          },
                          // {
                          //   label: 'ROP Upload',
                          //   onClick: () => handleRopClick(),
                          //   disabled: !formData.termsCondition,
                          // },
                        ]}
                      />
                    </div>
                  </div>
                </form>
              </div>
              <div className='col-md-7'></div>
              <div className='col-md-5'>
                <div className='row g-3 p-1 m-0 justify-content-center text-center'>
                  <div className='col-md-4'>
                    <RoundButton
                      label='Pay Premium'
                      iconClass='bi-chevron-right'
                      onClick={() => handlePayPremiumClick()}
                      disabled={!formData.termsCondition}
                    />
                  </div>
                  <div className='col-md-7'>
                    {/* <RoundButton
                      label='Request Policy Document'
                      iconClass='bi-chevron-right'
                      onClick={() => handleReqPolDocClick()}
                      disabled={!formData.termsCondition}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container pb-5 bg-steps-container'>
        <div className='row mt-4'>
          <div className='col-12 text-center'>
            <p className='bg-text text-center'>GET YOUR POLICY IN 3 SIMPLE STEPS</p>
          </div>

          {/* Step Container with Route Line */}
          <div className='row m-0 p-0 bg-steps'>

            {/* Step 1 - Top */}
            <div className='col-12 col-md-4 d-flex justify-content-center align-items-start step-wrapper'>
              <div className='step-content text-center'>
                <div className='step-circle'>
                  <img src={DocumentImage} alt='Step 1' className='img-fluid step-icon' />
                </div>
                <p className='line-title mb-0'>Simplified Input</p>
                <p className='line-title-small mt-0'>
                  Upload your Mulkiya and Driving License. Select Insurance Type
                </p>
              </div>
            </div>

            {/* Step 2 - Center */}
            <div className='col-12 col-md-4 d-flex justify-content-center align-items-end step-wrapper mt-md-5'>
              <div className='step-content text-center'>
                <div className='step-circle'>
                  <img src={HandBoxImage} alt='Step 2' className='img-fluid step-icon' />
                </div>
                <p className='line-title mb-0'>Instant Quote</p>
                <p className='line-title-small mt-0'>
                  Get your Motor Insurance Quote instantly and Proceed to Pay your Premium.
                </p>
              </div>
            </div>

            {/* Step 3 - Bottom */}
            <div className='col-12 col-md-4 d-flex justify-content-center align-items-start step-wrapper'>
              <div className='step-content text-center'>
                <div className='step-circle'>
                  <img src={PreviewDocumentImage} alt='Step 3' className='img-fluid step-icon' />
                </div>
                <p className='line-title mb-0'>Receive Policy</p>
                <p className='line-title-small mt-0'>
                  Receive your policy in your preferred communication mode (WhatsApp, Email)
                </p>
              </div>
            </div>
              <svg class="connector" viewBox="0 0 1000 300" preserveAspectRatio="none">
              <path d="M 50 -250 
                      C 200 350, 400 -100, 550 150 
                      S 900 -100, 830 -200"
                    stroke="#b9b9b9"
                    stroke-width="1"
                    stroke-dasharray="3,3"
                    fill="transparent"/>
            </svg>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#fff',
        }}
      >
        <div className='container p-2 m-5'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-12 d-flex justify-content-center align-items-center mb-4 mb-lg-0'>
              <img
                src={MotorInsurImage}
                alt='Motor Insurance'
                className='motor-insurance-img'
              />
            </div>

            <div className='col-lg-6 col-md-12'>
              <h2 className='motor-section-text'>Motor Insurance</h2>
              <div className='motor-text-container'>
                <p className='motor-text mt-4'>
                  Motor insurance isn’t just a legal requirement, it’s your
                  safety net against financial losses from accidents, damages
                  and third party liabilities. By choosing the right policy, you
                  can drive with confidence, knowing that both you and your
                  vehicle are protected.
                </p>
                <p className='motor-text mt-4'>
                  <b>Comprehensive insurance</b> offers the broadest protection,
                  covering damages to your own vehicle, third-party liabilities,
                  even some unforeseen events like natural disasters and
                  personal accidents. Ideal for car owners seeking peace of mind
                  and willing to invest a bit more for wider coverage.
                </p>
                <p className='motor-text mt-4'>
                  <b>Third-party insurance</b> covers liability to a third party
                  in case of an accident. This is a basic legal requirement, but
                  will not cover you for most things happen.
                </p>
                <p className='motor-text mt-4'>
                  When comparing policies, remember: a cheaper premium may come
                  with limited coverage or after-sales support. Look beyond the
                  price to ensure you’re getting services like roadside
                  assistance, faster claim settlements, and dedicated customer
                  service.
                </p>
              </div>
              <div className='col-lg-5'>
                <PrimaryRoundButton
                  label='Insure Your Vehicle Today'
                  iconClass='bi-chevron-right'
                  onClick={handleBuyPolicyClick}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div className='container p-2 p-md-2 m-5'>
          <div className='row align-items-center'>
            <div className='col-lg-6 col-md-12'>
              <h2 className='motor-section-text'>
                WHY CHOOSE DHOFAR INSURANCE?
              </h2>
              <div className='motor-text-container'>
                <div className='motor-benefits mt-5'>
                  <ul className='list-unstyled'>
                    <li className='mb-4'>
                      <strong className='motor-head'>
                        • Largest Branch Network in the Sultanate of Oman
                      </strong>
                      <p className='motor-text mt-2 mb-0 ms-3'>
                        Enjoy convenient, in-person support wherever you are,
                        without traveling miles to insure your car.
                      </p>
                    </li>
                    <li className='mb-4'>
                      <strong className='motor-head'>
                        • Extensive Claims Handling Network
                      </strong>
                      <p className='motor-text mt-2 mb-0 ms-3'>
                        Largest network for motor claim settlements, ensuring
                        your claims are processed quickly and efficiently.
                      </p>
                    </li>
                    <li className='mb-4'>
                      <strong className='motor-head'>
                        • Efficient & Effective Claims Management
                      </strong>
                      <p className='motor-text mt-2 mb-0 ms-3'>
                        From intimation to settlement, our streamlined process
                        saves you time and hassle.
                      </p>
                    </li>
                    <li className='mb-4'>
                      <strong className='motor-head'>
                        • Decades of Insurance Industry Expertise
                      </strong>
                      <p className='motor-text mt-2 mb-0 ms-3'>
                        Rely on our proven track record in Oman's motor
                        insurance sector—your confidence is our commitment.
                      </p>
                    </li>
                    <li className='mb-4'>
                      <strong className='motor-head'>
                        • Professionally Trained Employees
                      </strong>
                      <p className='motor-text mt-2 mb-0 ms-3'>
                        Our highly skilled team provides reliable guidance and
                        personalized solutions to match your unique needs.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-lg-4'>
                <PrimaryRoundButton
                  label='Renew Your Policy'
                  iconClass='bi-chevron-right'
                  onClick={handleRenewPolicyClick}
                />
              </div>
            </div>

            <div className='col-lg-6 col-md-12 d-flex justify-content-center align-items-center mb-4 mb-lg-0'>
              <img
                src={PolicyImage}
                alt='Motor Insurance'
                className='motor-insurance-img'
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
